import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  clinicId: yup.number().required(),
  merchantId: yup.number().required(),
});

export function useUpdatePosConnectionMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.post(HTTP_ENDPOINTS.updatePosConnection(), {
      clinic_id: req.clinicId,
      merchant_id: req.merchantId,
    });
  }, options);
}
